import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {
    CreateMenu,
    GetAllCourseType,
    GetAllItem,
    GetAllMeals,
    UpdateMenu,
    GetMenuByCafeteriaIdServingDate,
    DeleteDepartmentById,
    DeleteMealTimeById,
    DeleteUserById, GetAllMealForecast,
} from './MenuApi';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const MenuSlice = createSlice({
    name: 'menu',
    initialState: {
        allMeals: null,
        allCourseType: null,
        createMenus: null,
        updateMenus: null,
        allItem: null,
        menuByCafeteriaIdServingDate: null,
        deleteDepartement:null,
        deleteMealTime:null,
        deleteUser:null,
        getAllMealForecast: []
    },
    reducers: {
        clearGetAllMealForecast: (state, action) => {
            state.getAllMealForecast = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllMeals.fulfilled, (state, { payload }) => {
                state.allMeals = ResponseApi(payload);
            })
            .addCase(GetAllCourseType.fulfilled, (state, { payload }) => {
                state.allCourseType = ResponseApi(payload);
            })
            .addCase(GetAllItem.fulfilled, (state, { payload }) => {
                state.allItem = ResponseApi(payload);
            })
            .addCase(CreateMenu.fulfilled, (state, { payload }) => {
                state.createMenus = ResponseApi(payload);
            })
            .addCase(UpdateMenu.fulfilled, (state, { payload }) => {
                state.updateMenus = ResponseApi(payload);
            })
            .addCase(GetMenuByCafeteriaIdServingDate.fulfilled, (state, { payload }) => {
                state.menuByCafeteriaIdServingDate = ResponseApi(payload);
            })
            .addCase(DeleteDepartmentById.fulfilled, (state, { payload }) => {
                state.deleteDepartement = ResponseApi(payload);
            })
            .addCase(DeleteMealTimeById.fulfilled, (state, { payload }) => {
                state.deleteMealTime = ResponseApi(payload);
            })
            .addCase(DeleteUserById.fulfilled, (state, { payload }) => {
                state.deleteUser = ResponseApi(payload);
            })
            .addCase(GetAllMealForecast.fulfilled, (state, { payload }) => {
                state.getAllMealForecast = ResponseApi(payload);
            });
    },
});

export const { clearGetAllMealForecast } = MenuSlice.actions;

export default MenuSlice.reducer;
